import { Button, Flex, Card, Text, Separator, withStates } from '@amigoapp/doca-react';

const ContentWithStates = withStates(Flex);

const ConsentTerm = ({ loading, consentTerm, onBackClick, onAcceptConsentTermClick }) => (
	<Flex align="center" className="doca-px-4" direction="col" flex={1} gap={4} justify="between">
		<Card className="doca-py-4 doca-px-8 doca-mt-8 telemedicine-card">
			<ContentWithStates direction="col" loading={loading}>
				<Text as="h1" className="doca-text--center" size="large">
					Termo de Uso e Consentimento.
				</Text>
				<Separator className="doca-w-full" />
				<Text
					className="doca-mt-2 doca-mb-6 consent-term"
					loading={loading}
					size="small"
					variant="gray"
					weight="light"
				>
					{consentTerm}
				</Text>
				<Flex className="consent-term-actions" gap={4} justify="center">
					<Button disabled={loading} variant="secondary" onClick={onBackClick}>Fechar</Button>
					<Button disabled={loading} variant="primary" onClick={onAcceptConsentTermClick}>Li e Aceito</Button>
				</Flex>
			</ContentWithStates>
		</Card>
		<img alt="Amigo - Logo" className="doca-w-32 doca-mb-8" src="https://cdn.amigotech.com.br/logos/amigo.svg" />
	</Flex>
);

export default ConsentTerm;
